import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconNotificationError = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M9 8V5a1 1 0 10-2 0v3a1 1 0 102 0zm-.29 3.71a1.004 1.004 0 10-1.42-1.42 1.004 1.004 0 001.42 1.42z'
                    fill='#FFF'
                />
                <path
                    d='M8 16A8 8 0 118 0a8 8 0 010 16zm1-8V5a1 1 0 10-2 0v3a1 1 0 102 0zm-.29 3.71a1.004 1.004 0 10-1.42-1.42 1.004 1.004 0 001.42 1.42z'
                    fill='#B81237'
                />
            </g>
        </svg>
    );
};

IconNotificationError.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
};
IconNotificationError.defaultProps = {
    size: 'sm',
    focusable: false,
};
export default IconNotificationError;
